import React, { useEffect, useRef } from "react";
import TeamImage from '../../images/owner.jpeg';
import { Link } from 'react-router-dom'
import heroImage from '../../images/ETSrose.png'
import Stars from '../../images/stars.png'
import { motion, useAnimation, useInView } from "framer-motion";


const Herosection = () => {

  const ref = useRef(null);
    const isInView = useInView(ref);
  
    const mainControlls = useAnimation();

    // Trigger animations when elements are in view
    useEffect(() => {
      if (isInView) {
        mainControlls.start("visible");
      }
    }, [isInView, mainControlls]);

  return (
    <div className="font-poppins overflow-x-hidden">
      {/* component from tailgrids */}

      <div className="relative  pt-[120px] pb-[110px] lg:pt-[150px] bg-[#e0e0e0]">
        <div className="container mx-auto px-10">
          <div className="-mx-4 flex flex-wrap">
            <div className="w-full px-4 lg:w-5/12">
              <div className="hero-content">
                <motion.div
                  variants={{
                    visible: { opacity: 1, y: 0 },
                    hidden: { opacity: 0, y: 75 },
                  }}
                  initial="hidden"
                  animate="visible"
                  transition={{ duration: 0.5, delay: 0.25 }}
                >
                  <h1 className="text-transparent bg-clip-text bg-gradient-to-r sm:text-8xl text-2xl from-blue-400 to-emerald-600 mb-3  font-bold leading-snug sm:text-[42px] lg:text-[40px] xl:text-[42px]">
                
                  <span className="sm:text-8xl text-6xl">
                      ETS Rose
                    </span>
                    <br />
                    Etablissement Rose                   
                  </h1>
                  <p className="text-body-color text-sm mb-8 max-w-[480px] sm:text-base">
                  Bienvenue chez ETS ROSE !
                  Nous sommes ravis de vous accueillir dans l’univers de l’énergie solaire et des solutions durables ! Chez ETS ROSE, nous croyons en un avenir où chaque foyer, entreprise et communauté a accès à une énergie propre, fiable et abordable.
                  </p>
                </motion.div>
                <motion.div
                  variants={{
                    visible: { opacity: 1, x: 0 },
                    hidden: { opacity: 0, x: -75 },
                  }}
                  initial="hidden"
                  animate="visible"
                  transition={{ duration: 0.5, delay: 0.25 }}
                >
                  <ul className="flex flex-wrap items-center">
                    <li>
                      <Link
                        to="/contact"
                        className="bg-blue-400 inline-flex items-center justify-center rounded-lg py-4 px-6 text-center text-base font-normal text-white hover:bg-blue-500 sm:px-10 lg:px-8 xl:px-10"
                      >
                        Commencer
                      </Link>
                    </li>
                  </ul>
                </motion.div>
              </div>
            </div>
            <div className="hidden px-4 lg:block lg:w-1/12"></div>
            <div className="w-full px-4 lg:w-6/12">
              <div className="lg:ml-auto lg:text-right">
                <motion.div
                  variants={{
                    visible: { opacity: 1, x: 0, filter: "blur(0px)" },
                    hidden: { opacity: 0, x: 75, filter: "blur(5px)" },
                  }}
                  initial="hidden"
                  animate="visible"
                  transition={{ duration: 0.5, delay: 0.25 }}
                  className="relative z-10 inline-block pt-11 lg:pt-0 mt-6"
                >
                  <img
                    src={heroImage}
                    alt="hero"
                    className="max-w-full lg:ml-auto rounded-l-[20%] rounded-br-[6%] w-[500px]" // Adjusted size
                  />
                  <img
                    src={Stars}
                    alt="stars"
                    className="z-20 w-28 absolute mt-[-105%] right-[-5%] opacity-70 hover:opacity-100"
                  />
                  <span className="absolute -left-8 -bottom-8 z-[-1]">
                    <svg
                      width="93"
                      height="93"
                      viewBox="0 0 93 93"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="2.5" cy="2.5" r="2.5" fill="#3056D3" />
                      <circle cx="2.5" cy="24.5" r="2.5" fill="#3056D3" />
                      <circle cx="2.5" cy="46.5" r="2.5" fill="#3056D3" />
                      <circle cx="2.5" cy="68.5" r="2.5" fill="#3056D3" />
                      <circle cx="2.5" cy="90.5" r="2.5" fill="#3056D3" />
                      <circle cx="24.5" cy="2.5" r="2.5" fill="#3056D3" />
                      <circle cx="24.5" cy="24.5" r="2.5" fill="#3056D3" />
                      <circle cx="24.5" cy="46.5" r="2.5" fill="#3056D3" />
                      <circle cx="24.5" cy="68.5" r="2.5" fill="#3056D3" />
                      <circle cx="24.5" cy="90.5" r="2.5" fill="#3056D3" />
                      <circle cx="46.5" cy="2.5" r="2.5" fill="#3056D3" />
                      <circle cx="46.5" cy="24.5" r="2.5" fill="#3056D3" />
                      <circle cx="46.5" cy="46.5" r="2.5" fill="#3056D3" />
                      <circle cx="46.5" cy="68.5" r="2.5" fill="#3056D3" />
                      <circle cx="46.5" cy="90.5" r="2.5" fill="#3056D3" />
                      <circle cx="68.5" cy="2.5" r="2.5" fill="#3056D3" />
                      <circle cx="68.5" cy="24.5" r="2.5" fill="#3056D3" />
                      <circle cx="68.5" cy="46.5" r="2.5" fill="#3056D3" />
                      <circle cx="68.5" cy="68.5" r="2.5" fill="#3056D3" />
                      <circle cx="68.5" cy="90.5" r="2.5" fill="#3056D3" />
                      <circle cx="90.5" cy="2.5" r="2.5" fill="#3056D3" />
                      <circle cx="90.5" cy="24.5" r="2.5" fill="#3056D3" />
                      <circle cx="90.5" cy="46.5" r="2.5" fill="#3056D3" />
                      <circle cx="90.5" cy="68.5" r="2.5" fill="#3056D3" />
                      <circle cx="90.5" cy="90.5" r="2.5" fill="#3056D3" />
                    </svg>
                  </span>
                </motion.div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <div className="sm:flex gap-12 items-center mx-10 my-10">
                        <motion.div
                          ref={ref}
                          variants={{
                            hidden: { opacity: 0, x: -75 },
                            visible: { opacity: 1, x: 0 },
                          }}
                          initial="hidden"
                          animate={mainControlls}
                          transition={{ duration: 0.5, delay: 0.25 }}
                          className="sm:w-1/2 w-full mb-8 sm:mb-0"
                        >
                          <img
                            alt="imageAbout"
                            src={TeamImage}
                            className="rounded-2xl shadow-lg sm:mx-auto object-cover hover:scale-105 transition-transform duration-300 w-80"
                          />
                        </motion.div>
                        
                        <motion.div
                          ref={ref}
                          variants={{
                            hidden: { opacity: 0, x: 75 },
                            visible: { opacity: 1, x: 0 },
                          }}
                          initial="hidden"
                          animate={mainControlls}
                          transition={{ duration: 0.5, delay: 0.25 }}
                          className="sm:w-1/2 w-full flex flex-col justify-center p-4 space-y-6"
                        >
                          <h1 className="text-5xl font-extrabold text-center my-6">À propos de notre entreprise</h1>
                          <p className="text-gray-700 text-base">
                            ETS ROSE est une entreprise engagée dans l'électrification durable à travers des solutions solaires innovantes et accessibles. Nous fournissons des produits et services solaires de haute qualité pour les ménages, ONG, services sociaux (écoles, hôpitaux), entreprises et coopératives.
                          </p>
                          <p className="text-gray-700 text-base">
                            Notre mission est simple : apporter la lumière et l’énergie à ceux qui en ont besoin, tout en réduisant l’empreinte carbone et en promouvant une énergie propre et renouvelable. Grâce à nos partenariats avec des experts du secteur et au respect des normes internationales, nous garantissons des solutions fiables, durables et adaptées à tous les besoins.
                          </p>
                        </motion.div>
                      </div> {/* End of flex container with image and detailed info */}

      {/* component from tailgrids end */}
    </div>
  );
}

export default Herosection